/**
 * 家具カテゴリとサブタイプの定数定義
 */

// 家具カテゴリ一覧（サブタイプ別サイズ定義付き）
export const CATEGORIES = [
    {
        id: 'desk',
        name: 'デスク',
        icon: '🖥️',
        defaultSize: { width: 150, depth: 60, height: 75 },
        subtypeSizes: {
            default: { width: 150, depth: 60, height: 75 },
            pc: { width: 120, depth: 60, height: 75 },
            lowTable: { width: 90, depth: 45, height: 35 },
        }
    },
    {
        id: 'chair',
        name: 'チェア',
        icon: '🪑',
        defaultSize: { width: 50, depth: 50, height: 100 },
        subtypeSizes: {
            default: { width: 50, depth: 50, height: 100 },
            desk: { width: 50, depth: 50, height: 85 },
            gaming: { width: 65, depth: 65, height: 130 },
            sofa: { width: 180, depth: 85, height: 80 },
            floor: { width: 50, depth: 70, height: 80 },
        }
    },
    {
        id: 'bed',
        name: 'ベッド',
        icon: '🛏️',
        defaultSize: { width: 100, depth: 200, height: 45 },
        subtypeSizes: {
            default: { width: 100, depth: 200, height: 45 },
            standard: { width: 100, depth: 200, height: 45 },
            mattress: { width: 100, depth: 200, height: 20 },
            loft: { width: 100, depth: 200, height: 180 },
        }
    },
    {
        id: 'shelf',
        name: '棚',
        icon: '📚',
        defaultSize: { width: 60, depth: 40, height: 100 },
        subtypeSizes: {
            default: { width: 60, depth: 40, height: 100 },
            bookshelf: { width: 80, depth: 30, height: 180 },
            storage: { width: 60, depth: 40, height: 90 },
            tvStand: { width: 120, depth: 40, height: 45 },
            hanger: { width: 90, depth: 45, height: 170 },
        }
    },
    {
        id: 'appliances',
        name: '家電',
        icon: '🔌',
        defaultSize: { width: 50, depth: 50, height: 100 },
        subtypeSizes: {
            default: { width: 50, depth: 50, height: 100 },
            refrigerator: { width: 55, depth: 60, height: 170 },
            washer: { width: 60, depth: 60, height: 100 },
        }
    },
    {
        id: 'others',
        name: 'その他',
        icon: '🪴',
        defaultSize: { width: 50, depth: 50, height: 100 },
        subtypeSizes: {
            default: { width: 50, depth: 50, height: 100 },
            mirror: { width: 37, depth: 36, height: 160 },
            plant: { width: 30, depth: 30, height: 100 },
        }
    },
    {
        id: 'custom',
        name: 'カスタム',
        icon: '📦',
        defaultSize: { width: 100, depth: 100, height: 100 },
        subtypeSizes: {
            default: { width: 100, depth: 100, height: 100 },
        }
    },
]

// カテゴリ別のサブタイプオプション
export const SUBTYPE_OPTIONS = {
    desk: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'pc', label: 'パソコンデスク' },
        { value: 'lowTable', label: 'ローテーブル' },
    ],
    chair: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'desk', label: 'デスクチェア' },
        { value: 'gaming', label: 'ゲーミングチェア' },
        { value: 'sofa', label: 'ソファ' },
        { value: 'floor', label: '座椅子' },
    ],
    bed: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'standard', label: '標準ベッド' },
        { value: 'mattress', label: 'マットレス' },
        { value: 'loft', label: 'ロフトベッド' },
    ],
    shelf: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'bookshelf', label: '本棚' },
        { value: 'storage', label: 'カラーボックス' },
        { value: 'tvStand', label: 'テレビ台' },
        { value: 'hanger', label: 'ハンガーラック' },
    ],
    appliances: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'refrigerator', label: '冷蔵庫' },
        { value: 'washer', label: '洗濯機' },
    ],
    others: [
        { value: 'default', label: '四角（デフォルト）' },
        { value: 'mirror', label: '全身鏡' },
        { value: 'plant', label: '観葉植物' },
    ],
    custom: [
        { value: 'default', label: '四角（デフォルト）' },
    ],
}

// 家具サイズの制限値
export const FURNITURE_SIZE_LIMITS = {
    width: { min: 20, max: 300 },
    depth: { min: 20, max: 300 },
    height: { min: 20, max: 300 },
    rotation: { min: -180, max: 180 },
}
